<template>
  <el-dialog v-loading="isLoading" :title="title" :visible.sync="dialogFormVisible" top="8vh" width="600px"
    element-loading-text="加载中" @close="close">
    <el-form v-if="dialogFormVisible" ref="form" :model="form" :rules="rules" label-width="120px">
      <!-- 所属状态 -->
      <!-- 退款方式 -->
      <!-- <el-form-item v-if="form.gtype == 2" label="退款方式" prop="refund_type" style="margin-bottom: 15px">
        <el-radio-group v-model="form.refund_type">
          <el-radio :label="0">全额退款</el-radio>
          <el-radio v-if="bufen_refund" :label="1">部分退款</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item v-if="type == 5" label="退款商品" prop="refund_type" style="margin-bottom: 15px">
        <div v-for="(item, index) in form.goods_order_apply" :key="index" class="tui_sku_class">
          <img :src="item.goods.pic" alt="" style="width: 80px; height: 80px" />
          <div class="tui_sku_class_right">
            <span>规格：{{ item.goods.sku }}</span>
            <span>数量：{{ item.refund_num }}</span>
            <span>价格：{{ item.apply_amount }}</span>
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="退款积分" prop="point_tui" style="margin-bottom: 15px">
        <el-input v-model="form.point_tui" type="text" show-word-limit maxlength="15" :placeholder="placeholder_point"
          @input="inputPointChange"></el-input>
      </el-form-item> -->



      <el-form-item label="退款(余额)" style="margin-bottom: 15px">
        <el-input v-model="form.user_balance" disabled></el-input>
      </el-form-item>
      <el-form-item label="退款(现金)" style="margin-bottom: 15px">
        <el-input v-model="form.price" disabled type="text"></el-input>
      </el-form-item>

      <!-- <el-form-item label="退款金额" prop="price_tui" style="margin-bottom: 15px">
        <el-input v-model="form.price_tui" type="text" show-word-limit maxlength="10" :placeholder="placeholder"
          @input="inputChange"></el-input>
      </el-form-item> -->
      <el-form-item label="退款原因">
        <el-input v-model="form.remark" disabled type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">返回</el-button>

      <el-button type="warning" @click="refundReject">退款驳回</el-button>
      <el-button type="primary" @click="refundAgree">退款同意</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  orderRefundRefund,
  order_apply_refund_detail,
  buyDetail,
  goods_refund,
  refuse_refund,
  buy_order_apply_refund_detail,
  buy_refund
} from '@/api/xgcApi'
export default {
  name: 'UserManagementEdit',
  components: {},
  props: {
    bufen_refund: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      isLoading: false,
      id: '',
      form: {
        id: '',
        user_balance: '',
        remark: '', //退款原因
        price: '',
      },
      title: '申请退款',
      placeholder: '',
      rules: {
      },
      type: 1,
    }
  },

  methods: {
    close() {
      this.dialogFormVisible = false
    },
    open(row, type) {

      this.type = type
      console.log(row, type, '98989898')

      console.log(type, '代买3')
      console.log(type, '代付4')

      this.id = row.id
      this.form = {
        ...this.form,
        ...row,
      }
      if (this.form.gtype == 2) {
        // 商品退款
        var data = {
          order_id: this.form.id,
        }
        order_apply_refund_detail(data)
          .then((res) => {
            this.dialogFormVisible = true
            this.form = res.data
            this.tui_goods_spec_list = res.data.goods_order_apply
          })
          .catch((err) => { })
      } else {
        var data = {
          order_id: this.id,
        }

        buy_order_apply_refund_detail(data).then((res) => {
          this.form = res.data
          this.dialogFormVisible = true
          console.log(res, '======')

          return
          if (res.data.pay_type == 1) {
            // 全积分支付
            this.max = '0.00'
            this.form.price = 0
            this.placeholder_point = `退团积分不能超过${this.form.deduction_points}积分`
            this.placeholder = `退团金额不能超过${this.max}元`
          } else {
            // 现金支付/现金积分混合支付
            this.max = Number(row.price) - Number(row.refund_price)
            this.max = this.max.toFixed(2)
            this.placeholder_point = `退团积分不能超过${this.form.deduction_points}积分`
            this.placeholder = `退团金额不能超过${this.max}元`
          }
          this.form.point_tui = null
          this.form.price_tui = null
          this.form.dsc = ''
          this.dialogFormVisible = true
        })
      }
    },
    // 退款同意
    refundAgree() {
      this.$prompt('确定进行退款操作,输入退款备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        // 代买代付
        if (this.type == 3 || this.type == 4) {
          this.isLoading = true
          buy_refund({
            id: this.id,
            refund_type: 0,
            refund_remarks: value
          })
            .then((res) => {
              this.$baseMessage('操作成功', 'success')
              this.$emit('change', true)
              this.dialogFormVisible = false
              this.isLoading = false
            })
            .catch((err) => {
              this.isLoading = false
            })
        } else {
          this.isLoading = true
          goods_refund({
            id: this.id,
            refund_remarks: value
          })
            .then((res) => {
              this.$baseMessage('操作成功', 'success')
              this.$emit('change', true)
              this.dialogFormVisible = false
              this.isLoading = false
            })
            .catch((err) => {
              this.isLoading = false
            })
        }

      }).catch(() => {
      });
    },
    // 退款驳回
    refundReject() {
      this.$prompt('请输入驳回理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.isLoading = true
        refuse_refund({
          order_id: this.id,
          refund_remarks: value
        }).then(res => {
          this.$message({
            type: 'success',
            message: '提交成功'
          });
          this.$emit('change', true)
          this.dialogFormVisible = false
          this.isLoading = false
        }).catch((err) => {
          this.isLoading = false
        })
      }).catch(() => {
      });
    },
  },
}
</script>
<style scoped>
:deep .el-select>.el-input {
  width: 430px;
}

.tui_sku_class {
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-bottom: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tui_sku_class_right {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 16px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
